import { getMap } from '../../atoms/map/utils/getMap'
import { findLayer } from '../utils/findLayer'

/**
 * Remove all Traffic area Features from the Map
 */
export function clearTrafficAreaFeatures() {
  const map = getMap()
  const layer = findLayer(map, 'trafficProfile')

  layer.getSource()?.clear()
}
